import store from '../../../../store';
import { createTagsService } from './TagsService.impl';

export const myTagsService = createTagsService(store);
